import { Flex, Text } from '@/components';
import { FALLBACK_TEXT } from '@/utils';
import type { FC } from 'react';
import {
  LEDGER_BG_COLOR,
  LEDGER_BORDER,
  LEDGER_PADDING,
  type TableRowType,
} from '../../../utils';

export const Table: FC<{ data: TableRowType; noneBorder?: boolean }> = ({
  data,
  noneBorder,
}) => {
  return (
    <Flex vertical flex={1}>
      {data.map(({ row, isHeader, vertical }, rowIdx) => {
        const isLastElement = rowIdx === data.length - 1;
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
          <Flex key={rowIdx} flex={1} vertical={vertical}>
            {row.map((cell, idx) => {
              const isMultipleCell = cell.type === 'multiple';
              return (
                <Flex
                  // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
                  key={idx}
                  style={{
                    flex: cell.ratio ?? 1,
                    breakInside: 'avoid',
                    textAlign: isHeader ? 'center' : undefined,
                    boxSizing: 'border-box',
                    backgroundColor: isHeader ? LEDGER_BG_COLOR : undefined,
                    borderBottom: isLastElement ? undefined : LEDGER_BORDER,
                    borderLeft: noneBorder
                      ? undefined
                      : idx === 0
                        ? LEDGER_BORDER
                        : undefined,
                    ...cell.cellStyle,
                  }}
                >
                  {isMultipleCell ? (
                    <Table data={cell.rows} />
                  ) : cell.type === 'element' ? (
                    <Flex
                      style={{
                        flex: 1,
                        breakInside: 'avoid',
                        boxSizing: 'border-box',
                        borderLeft: idx === 0 ? undefined : LEDGER_BORDER,
                        padding: LEDGER_PADDING,
                        ...cell.elementWrapperStyle,
                      }}
                    >
                      {cell.element}
                    </Flex>
                  ) : (
                    <Flex
                      style={{
                        flex: 1,
                        alignItems: 'center',
                        breakInside: 'avoid',
                        boxSizing: 'border-box',
                        borderLeft: idx === 0 ? undefined : LEDGER_BORDER,
                        padding: LEDGER_PADDING,
                        ...cell.textWrapperStyle,
                      }}
                    >
                      {cell.isSpace ? (
                        <div />
                      ) : (
                        <Text
                          text={cell.text || FALLBACK_TEXT}
                          variant="footnote"
                        />
                      )}
                    </Flex>
                  )}
                </Flex>
              );
            })}
          </Flex>
        );
      })}
    </Flex>
  );
};
